export default __webpack_public_path__ + "static/quotation-border-a55845486a065a322be83467570d5b3f.svg";